// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ENTERPRISE CLIENT DASHBOARD DESIGN SYSTEM
   Theme: Precision Clean SaaS Hybrid (Linear / Stripe / Vercel style)
   ========================================================================== */

*,
*::before,
*::after {
    box-sizing: border-box;
}

:root {
    /* Brand & Accent Tokens */
    --brand-primary: #4f46e5;
    --brand-primary-light: #eef2ff;
    --brand-primary-glow: rgba(79, 70, 229, 0.18);

    --color-emerald: #10b981;
    --color-emerald-light: #ecfdf5;
    --color-emerald-border: #a7f3d0;

    --color-amber: #f59e0b;
    --color-amber-light: #fffbeb;
    --color-amber-border: #fde68a;

    --color-sky: #0284c7;
    --color-sky-light: #f0f9ff;
    --color-sky-border: #bae6fd;

    --color-purple: #8b5cf6;
    --color-purple-light: #f5f3ff;
    --color-purple-border: #ddd6fe;

    /* Neutrals & Surfaces */
    --surface-bg: #f8fafc;
    --surface-card: #ffffff;
    --surface-subtle: #f1f5f9;
    --surface-border: #e2e8f0;
    --surface-border-subtle: #f1f5f9;

    /* Typography Colors */
    --text-heading: #0f172a;
    --text-body: #334155;
    --text-muted: #64748b;
    --text-light: #94a3b8;

    /* Elevation & Shadows */
    --shadow-subtle: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.04);
    --shadow-card: 0 4px 16px -2px rgba(15, 23, 42, 0.04), 0 2px 6px -1px rgba(15, 23, 42, 0.02);
    --shadow-hover: 0 12px 28px -4px rgba(15, 23, 42, 0.08), 0 4px 12px -2px rgba(15, 23, 42, 0.03);

    /* Radius & Font */
    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-full: 9999px;
    --font-heading: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

body {
    background-color: var(--surface-bg);
    font-family: var(--font-body);
    color: var(--text-body);
    margin: 0;
    -webkit-font-smoothing: antialiased;
}

.dashboard-wrapper {
    display: flex;
    min-height: 100vh;
    background-color: var(--surface-bg);
    width: 100%;
}

/* ==========================================================================
   SIDEBAR
   ========================================================================== */

.dash-sidebar {
    width: 240px;
    background-color: #ffffff;
    border-right: 1px solid var(--surface-border);
    display: flex;
    flex-direction: column;
    padding: 20px 14px;
    position: fixed;
    height: 100vh;
    z-index: 100;
}

.sidebar-logo {
    display: flex;
    align-items: center;
    padding: 0 6px 18px 6px;
    border-bottom: 1px solid var(--surface-border-subtle);
    margin-bottom: 16px;
}

.sidebar-logo img {
    height: 30px;
    max-width: 150px;
    object-fit: contain;
}

.sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.menu-item-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 9px 12px;
    border-radius: var(--radius-sm);
    color: var(--text-muted);
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
    transition: all 0.2s ease;
    position: relative;
}

.menu-item-link i {
    font-size: 15px;
    color: var(--text-light);
    transition: color 0.2s ease;
}

.menu-item-link:hover {
    color: var(--brand-primary);
    background-color: var(--brand-primary-light);
}

.menu-item-link:hover i {
    color: var(--brand-primary);
}

.menu-item-link.active {
    color: var(--brand-primary);
    background-color: var(--brand-primary-light);
    font-weight: 600;
}

.menu-item-link.active i {
    color: var(--brand-primary);
}

.menu-item-link.active::before {
    content: '';
    position: absolute;
    left: -14px;
    top: 6px;
    bottom: 6px;
    width: 4px;
    border-radius: 0 4px 4px 0;
    background: linear-gradient(180deg, var(--brand-primary), #6366f1);
}

.sidebar-help-card {
    background: linear-gradient(135deg, #f8f9ff 0%, #eef2ff 100%);
    border-radius: var(--radius-md);
    padding: 14px;
    margin-top: auto;
    text-align: center;
    border: 1px solid var(--color-purple-border);
}

.help-icon-wrapper {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--brand-primary);
    font-size: 16px;
    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.15);
    margin-bottom: 8px;
}

.sidebar-help-card h6 {
    font-family: var(--font-heading);
    font-size: 13.5px;
    font-weight: 700;
    color: var(--text-heading);
    margin-bottom: 3px;
}

.sidebar-help-card p {
    font-size: 11.5px;
    color: var(--text-muted);
    margin-bottom: 10px;
    line-height: 1.35;
}

.btn-contact-support {
    background: var(--brand-primary);
    color: #ffffff !important;
    font-size: 11.5px;
    font-weight: 600;
    padding: 7px 10px;
    border-radius: var(--radius-sm);
    transition: all 0.2s ease;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);
}

.btn-contact-support:hover {
    background: #4338ca;
    transform: translateY(-1px);
}

.sidebar-footer {
    font-size: 10.5px;
    color: var(--text-light);
    text-align: center;
    margin-top: 12px;
    line-height: 1.3;
}

/* ==========================================================================
   MAIN DASHBOARD WRAPPER & HEADER
   ========================================================================== */

.dash-main {
    flex: 1 1;
    margin-left: 240px;
    padding: 12px 20px 14px 20px;
    width: calc(100% - 240px);
    max-width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.dash-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--surface-border-subtle);
    margin-bottom: 12px;
}

.header-left-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-mobile-sidebar-toggle {
    display: none;
    width: 34px;
    height: 34px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--surface-border);
    background: #ffffff;
    color: var(--text-heading);
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.btn-mobile-sidebar-toggle:hover {
    background: var(--surface-subtle);
    border-color: #cbd5e1;
    color: var(--brand-primary);
}

.btn-sidebar-close-mobile {
    display: none;
    width: 30px;
    height: 30px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    cursor: pointer;
    margin-left: auto;
    transition: all 0.2s ease;
}

.btn-sidebar-close-mobile:hover {
    background: #fee2e2;
    color: #ef4444;
    border-color: #fecaca;
}

.sidebar-mobile-backdrop {
    display: none;
}

.header-page-title h3 {
    font-family: var(--font-heading);
    font-size: 17px;
    font-weight: 700;
    color: var(--text-heading);
    margin: 0;
    letter-spacing: -0.3px;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.notification-btn {
    width: 34px;
    height: 34px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--surface-border);
    background: #ffffff;
    color: var(--text-muted);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13.5px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.notification-btn:hover {
    background: var(--surface-subtle);
    color: var(--brand-primary);
    border-color: #cbd5e1;
    transform: translateY(-1px);
}

.notification-badge {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--color-amber);
    border: 1.5px solid #ffffff;
}

.user-profile-card {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 2px 10px 2px 3px;
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-full);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    transition: all 0.2s ease;
}

.user-profile-card:hover {
    border-color: #c7d2fe;
    box-shadow: 0 2px 6px rgba(99, 102, 241, 0.1);
    transform: translateY(-1px);
}

.user-avatar-circle {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--brand-primary), #8b5cf6);
    color: #ffffff;
    font-family: var(--font-heading);
    font-size: 10.5px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(99, 102, 241, 0.25);
    flex-shrink: 0;
}

.user-profile-details {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
    justify-content: center;
}

.user-profile-name {
    font-family: var(--font-heading);
    font-size: 12.5px;
    font-weight: 700;
    color: var(--text-heading);
    letter-spacing: -0.2px;
    white-space: nowrap;
    padding-right: 4px;
}

.user-profile-role {
    font-size: 9.5px;
    color: var(--brand-primary);
    font-weight: 600;
    text-transform: capitalize;
}

.logout-btn-styled {
    display: flex;
    align-items: center;
    gap: 5px;
    height: 34px;
    padding: 0 10px;
    border-radius: var(--radius-sm);
    border: 1px solid #fee2e2;
    background: #fff5f5;
    color: #ef4444;
    font-family: var(--font-heading);
    font-size: 11.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(239, 68, 68, 0.05);
}

.logout-btn-styled:hover {
    background: #fee2e2;
    color: #dc2626;
    border-color: #fca5a5;
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(239, 68, 68, 0.12);
}

/* ==========================================================================
   HERO BAR & CUSTOM PROJECT DROPDOWN
   ========================================================================== */

.dashboard-hero-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    gap: 12px;
    flex-wrap: wrap;
    position: relative;
    z-index: 30;
}

.hero-welcome-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.hero-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 8px;
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-full);
    font-size: 10px;
    font-weight: 600;
    color: var(--brand-primary);
    width: fit-content;
    box-shadow: var(--shadow-subtle);
}

.pulse-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: var(--color-emerald);
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.25);
    animation: pulseGlow 2s infinite ease-in-out;
}

@keyframes pulseGlow {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 5px rgba(16, 185, 129, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
    }
}

.hero-title {
    font-family: var(--font-heading);
    font-size: 18px;
    font-weight: 800;
    color: var(--text-heading);
    margin: 0;
    letter-spacing: -0.3px;
}

.hero-subtitle {
    font-size: 11.5px;
    color: var(--text-muted);
    margin: 0;
}

.hero-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
}

/* Sleek Floating Project Dropdown */
.project-dropdown-wrapper {
    position: relative;
    min-width: 200px;
}

.project-dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    padding: 7px 12px;
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-subtle);
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    outline: none;
}

.project-dropdown-trigger:hover,
.project-dropdown-trigger.active {
    border-color: var(--brand-primary);
    box-shadow: 0 0 0 3px var(--brand-primary-glow);
    background: #ffffff;
}

.project-trigger-left {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.project-trigger-icon {
    font-size: 13px;
    color: var(--brand-primary);
    flex-shrink: 0;
}

.project-trigger-name {
    font-family: var(--font-heading);
    font-size: 12.5px;
    font-weight: 700;
    color: var(--text-heading);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 170px;
}

.project-trigger-chevron {
    font-size: 10.5px;
    color: var(--text-light);
    transition: transform 0.25s ease, color 0.2s ease;
    flex-shrink: 0;
}

.project-trigger-chevron.open {
    transform: rotate(180deg);
    color: var(--brand-primary);
}

.project-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 240px;
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-md);
    box-shadow: 0 12px 28px -4px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.06);
    overflow: hidden;
    animation: dropdownFadeSlide 0.18s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 100;
}

@keyframes dropdownFadeSlide {
    from {
        opacity: 0;
        transform: translateY(-6px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

.project-dropdown-header {
    padding: 8px 12px;
    background: #fafbfc;
    border-bottom: 1px solid var(--surface-border-subtle);
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--text-muted);
}

.project-dropdown-list {
    padding: 4px;
    max-height: 220px;
    overflow-y: auto;
}

.project-dropdown-item {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 7px 10px;
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: all 0.15s ease;
}

.project-dropdown-item:hover {
    background: var(--brand-primary-light);
}

.project-dropdown-item.selected {
    background: #eef2ff;
}

.item-icon-wrap {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: var(--text-muted);
    flex-shrink: 0;
    transition: all 0.15s ease;
}

.project-dropdown-item:hover .item-icon-wrap,
.project-dropdown-item.selected .item-icon-wrap {
    background: var(--brand-primary);
    color: #ffffff;
}

.item-name {
    flex: 1 1;
    font-size: 12px;
    font-weight: 600;
    color: var(--text-heading);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.project-dropdown-item.selected .item-name {
    color: var(--brand-primary);
    font-weight: 700;
}

.item-check {
    font-size: 13px;
    color: var(--brand-primary);
    font-weight: 800;
}

.project-dropdown-empty {
    padding: 12px;
    text-align: center;
    color: var(--text-muted);
    font-size: 11.5px;
}

/* ==========================================================================
   KPI STAT CARDS (TOP 5 CARDS)
   ========================================================================== */

.stats-kpi-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    margin-bottom: 12px;
}

.kpi-card {
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-md);
    padding: 9px 12px 8px 12px;
    box-shadow: var(--shadow-card);
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-hover);
    border-color: #cbd5e1;
}

.kpi-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
}

.kpi-card-purple::after {
    background: linear-gradient(90deg, #8b5cf6, #a855f7);
}

.kpi-card-green::after {
    background: linear-gradient(90deg, #10b981, #34d399);
}

.kpi-card-amber::after {
    background: linear-gradient(90deg, #f59e0b, #fbbf24);
}

.kpi-card-sky::after {
    background: linear-gradient(90deg, #0284c7, #38bdf8);
}

.kpi-card-indigo::after {
    background: linear-gradient(90deg, #4f46e5, #6366f1);
}

.kpi-card-header-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 5px;
}

.kpi-title-text {
    font-size: 10.5px;
    font-weight: 700;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.kpi-icon-pill {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.icon-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
}

.icon-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
}

.icon-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
}

.icon-sky {
    background: var(--color-sky-light);
    color: var(--color-sky);
}

.icon-indigo {
    background: var(--brand-primary-light);
    color: var(--brand-primary);
}

.kpi-value-container {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 5px;
}

.kpi-big-number {
    font-family: var(--font-heading);
    font-size: 20px;
    font-weight: 800;
    color: var(--text-heading);
    line-height: 1;
    letter-spacing: -0.4px;
}

.kpi-tag-chip {
    font-size: 9.5px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: var(--radius-full);
}

.tag-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
    border: 1px solid var(--color-purple-border);
}

.tag-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
    border: 1px solid var(--color-emerald-border);
}

.tag-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
    border: 1px solid var(--color-amber-border);
}

.tag-sky {
    background: var(--color-sky-light);
    color: var(--color-sky);
    border: 1px solid var(--color-sky-border);
}

.tag-indigo {
    background: var(--brand-primary-light);
    color: var(--brand-primary);
    border: 1px solid #c7d2fe;
}

.kpi-mini-track {
    height: 3px;
    background-color: var(--surface-subtle);
    border-radius: var(--radius-full);
    overflow: hidden;
    margin-bottom: 4px;
}

.kpi-mini-fill {
    height: 100%;
    border-radius: var(--radius-full);
    transition: width 0.6s ease;
}

.bg-purple {
    background-color: var(--color-purple);
}

.bg-green {
    background-color: var(--color-emerald);
}

.bg-amber {
    background-color: var(--color-amber);
}

.bg-sky {
    background-color: var(--color-sky);
}

.bg-indigo {
    background-color: var(--brand-primary);
}

.kpi-caption {
    font-size: 10px;
    color: var(--text-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ==========================================================================
   PRO CARDS
   ========================================================================== */

.pro-card {
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-card);
    transition: all 0.2s ease;
}

.pro-card:hover {
    box-shadow: var(--shadow-hover);
    border-color: #cbd5e1;
}

.pro-card-header {
    padding: 9px 14px;
    border-bottom: 1px solid var(--surface-border-subtle);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-title-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

.card-title-icon {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.indigo-soft {
    background: var(--brand-primary-light);
    color: var(--brand-primary);
}

.green-soft {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
}

.amber-soft {
    background: var(--color-amber-light);
    color: var(--color-amber);
}

.sky-soft {
    background: var(--color-sky-light);
    color: var(--color-sky);
}

.purple-soft {
    background: var(--color-purple-light);
    color: var(--color-purple);
}

.pro-card-title {
    font-family: var(--font-heading);
    font-size: 13px;
    font-weight: 700;
    color: var(--text-heading);
    margin: 0;
    line-height: 1.2;
}

.pro-card-subtitle {
    font-size: 10.5px;
    color: var(--text-muted);
}

.pro-view-all-btn {
    font-size: 11px;
    font-weight: 600;
    color: var(--brand-primary);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    transition: all 0.2s ease;
}

.pro-view-all-btn:hover {
    color: #4338ca;
    transform: translateX(2px);
}

/* ==========================================================================
   MIDDLE ROW (3 CARDS)
   ========================================================================== */

.analytics-spotlight-grid {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1.15fr;
    gap: 12px;
    margin-bottom: 12px;
}

/* Card 1: Project Progress */
.project-progress-card .overall-progress-body {
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.live-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 10.5px;
    font-weight: 700;
    color: var(--color-emerald);
    background: var(--color-emerald-light);
    border: 1px solid var(--color-emerald-border);
    padding: 2px 7px;
    border-radius: var(--radius-full);
}

.status-indicator-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: var(--color-emerald);
}

.progress-metric-display {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 8px;
}

.big-metric-percent {
    font-family: var(--font-heading);
    font-size: 26px;
    font-weight: 800;
    color: var(--text-heading);
    letter-spacing: -0.6px;
    line-height: 1;
}

.percent-symbol {
    font-size: 16px;
    font-weight: 700;
    color: var(--brand-primary);
    margin-left: 2px;
}

.metric-status-text {
    font-size: 11px;
    font-weight: 500;
    color: var(--text-muted);
}

.pro-progress-bar-container {
    height: 7px;
    background-color: var(--surface-subtle);
    border-radius: var(--radius-full);
    overflow: hidden;
    margin-bottom: 10px;
}

.pro-progress-bar-fill {
    height: 100%;
    border-radius: var(--radius-full);
    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.gradient-primary {
    background: linear-gradient(90deg, #6366f1 0%, #4f46e5 100%);
}

.project-meta-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--surface-border-subtle);
}

.meta-box {
    display: flex;
    align-items: center;
    gap: 6px;
}

.meta-box-icon {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: var(--surface-subtle);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
    font-size: 11px;
    flex-shrink: 0;
}

.meta-box-content {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.meta-box-label {
    font-size: 9.5px;
    font-weight: 600;
    color: var(--text-light);
    text-transform: uppercase;
}

.meta-box-value {
    font-size: 11px;
    font-weight: 700;
    color: var(--text-heading);
}

/* Card 2: Donut Chart */
.milestone-distribution-card {
    display: flex;
    flex-direction: column;
}

.donut-chart-layout {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1 1;
    justify-content: center;
}

.donut-visual-container {
    position: relative;
    width: 102px;
    height: 102px;
    flex-shrink: 0;
}

.donut-svg-modern {
    transform: rotate(-90deg);
    transform-origin: 48px 48px;
    width: 102px;
    height: 102px;
}

.donut-segment {
    transition: stroke-dasharray 0.6s ease;
}

.donut-center-badge {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.donut-center-count {
    font-family: var(--font-heading);
    font-size: 19px;
    font-weight: 800;
    color: var(--text-heading);
    line-height: 1;
}

.donut-center-tag {
    font-size: 9px;
    font-weight: 700;
    color: var(--text-light);
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.donut-legend-modern {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    gap: 8px;
    flex: 1 1;
    height: 100%;
    max-height: 104px;
}

.legend-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3px 0;
}

.legend-title-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
}

.legend-indicator {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    flex-shrink: 0;
}

.dot-green {
    background-color: var(--color-emerald);
}

.dot-amber {
    background-color: var(--color-amber);
}

.dot-purple {
    background-color: var(--color-purple);
}

.legend-name {
    font-size: 11.5px;
    font-weight: 600;
    color: var(--text-heading);
}

.legend-stats-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
}

.legend-count {
    font-family: var(--font-heading);
    font-size: 12.5px;
    font-weight: 800;
    color: var(--text-heading);
    min-width: 10px;
    text-align: right;
}

.legend-percent-pill {
    font-size: 9.5px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: var(--radius-full);
    min-width: 32px;
    text-align: center;
}

.pill-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
    border: 1px solid var(--color-emerald-border);
}

.pill-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
    border: 1px solid var(--color-amber-border);
}

.pill-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
    border: 1px solid var(--color-purple-border);
}

/* Card 3: Current Milestone Spotlight */
.current-milestone-body {
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.current-status-badge {
    font-size: 10px;
    font-weight: 700;
    color: var(--color-amber);
    background: var(--color-amber-light);
    border: 1px solid var(--color-amber-border);
    padding: 1px 6px;
    border-radius: var(--radius-full);
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.spotlight-milestone-name {
    font-family: var(--font-heading);
    font-size: 15px;
    font-weight: 800;
    color: var(--text-heading);
    margin: 0 0 6px 0;
    line-height: 1.2;
}

.spotlight-dates-row {
    display: flex;
    gap: 5px;
    margin-bottom: 8px;
    flex-wrap: wrap;
}

.date-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 6px;
    background: var(--surface-subtle);
    border-radius: var(--radius-sm);
    font-size: 10.5px;
    font-weight: 500;
    color: var(--text-muted);
}

.date-chip i {
    color: var(--brand-primary);
}

.spotlight-progress-section {
    margin-bottom: 8px;
}

.progress-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
}

.progress-title {
    font-size: 10.5px;
    font-weight: 600;
    color: var(--text-muted);
}

.progress-val-badge {
    font-family: var(--font-heading);
    font-size: 11.5px;
    font-weight: 800;
    color: var(--color-amber);
}

.spotlight-progress-track {
    height: 6px;
    background-color: var(--surface-subtle);
    border-radius: var(--radius-full);
    overflow: hidden;
}

.spotlight-progress-fill {
    height: 100%;
    border-radius: var(--radius-full);
    transition: width 0.6s ease;
}

.gradient-amber {
    background: linear-gradient(90deg, #f59e0b, #fbbf24);
}

.spotlight-task-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--surface-border-subtle);
}

.task-stat-item {
    display: flex;
    align-items: center;
    gap: 6px;
}

.stat-icon-pill {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    flex-shrink: 0;
}

.stat-item-num {
    font-family: var(--font-heading);
    font-size: 13px;
    font-weight: 800;
    color: var(--text-heading);
    line-height: 1.1;
}

.stat-item-label {
    font-size: 10px;
    color: var(--text-muted);
    font-weight: 500;
}

/* ==========================================================================
   BOTTOM SECTION: ROADMAP TABLE + SIDE STACK (PERFECT BOTTOM ALIGNMENT)
   ========================================================================== */

.bottom-dashboard-grid {
    flex: 1 1;
    min-height: 0;
    display: grid;
    grid-template-columns: 1.75fr 1.25fr;
    gap: 12px;
    align-items: stretch;
    margin-bottom: 0;
}

/* Roadmap Table Card (Left Column) */
.milestones-table-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
}

.table-responsive-wrapper {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.pro-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11.5px;
    height: 100%;
    flex: 1 1;
}

.pro-table thead {
    flex-shrink: 0;
}

.pro-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafbfc;
    color: var(--text-muted);
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 7px 10px;
    border-bottom: 1px solid var(--surface-border);
    white-space: nowrap;
}

.pro-table tbody {
    height: 100%;
}

.pro-table tbody tr {
    border-bottom: 1px solid var(--surface-border-subtle);
    transition: background-color 0.15s ease;
    height: 1%;
}

.pro-table tbody tr:last-child {
    border-bottom: none;
}

.pro-table tbody tr:hover {
    background-color: #f8faff;
}

.pro-table tbody td {
    padding: 6px 10px;
    vertical-align: middle;
}

.cell-index {
    font-family: var(--font-heading);
    font-weight: 700;
    color: var(--text-light);
    font-size: 11px;
}

.cell-title {
    font-weight: 600;
}

.milestone-name-link {
    color: var(--text-heading);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: color 0.2s ease;
}

.milestone-name-link:hover {
    color: var(--brand-primary);
}

.milestone-bullet {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: var(--brand-primary);
    flex-shrink: 0;
}

.timeline-date-stack {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: var(--text-muted);
    white-space: nowrap;
}

.date-arrow {
    color: var(--text-light);
}

.table-progress-bar-wrap {
    display: flex;
    align-items: center;
    gap: 5px;
}

.table-bar-track {
    flex: 1 1;
    height: 5px;
    background-color: var(--surface-subtle);
    border-radius: var(--radius-full);
    overflow: hidden;
    min-width: 45px;
}

.table-bar-fill {
    height: 100%;
    border-radius: var(--radius-full);
    transition: width 0.4s ease;
}

.bg-emerald {
    background-color: var(--color-emerald);
}

.bg-amber {
    background-color: var(--color-amber);
}

.bg-slate {
    background-color: #94a3b8;
}

.table-bar-pct {
    font-size: 10.5px;
    font-weight: 700;
    color: var(--text-heading);
    width: 26px;
    text-align: right;
}

.status-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 7px;
    border-radius: var(--radius-full);
    font-size: 10.5px;
    font-weight: 600;
    white-space: nowrap;
}

.status-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
}

.status-pill-completed {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
    border: 1px solid var(--color-emerald-border);
}

.status-pill-completed .status-dot {
    background-color: var(--color-emerald);
}

.status-pill-progress {
    background: var(--color-amber-light);
    color: var(--color-amber);
    border: 1px solid var(--color-amber-border);
}

.status-pill-progress .status-dot {
    background-color: var(--color-amber);
}

.status-pill-pending {
    background: var(--surface-subtle);
    color: var(--text-muted);
    border: 1px solid var(--surface-border);
}

.status-pill-pending .status-dot {
    background-color: var(--text-light);
}

.task-action-chip {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 8px;
    background: var(--brand-primary-light);
    border: 1px solid #c7d2fe;
    color: var(--brand-primary);
    text-decoration: none;
    font-size: 10.5px;
    font-weight: 600;
    border-radius: var(--radius-sm);
    transition: all 0.2s ease;
    white-space: nowrap;
}

.task-action-chip:hover {
    background: var(--brand-primary);
    color: #ffffff;
    border-color: var(--brand-primary);
    transform: translateY(-1px);
}

.table-empty-state {
    padding: 24px 14px !important;
    text-align: center;
}

.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--text-light);
}

.empty-icon {
    font-size: 24px;
    margin-bottom: 4px;
}

/* Modern Sleek Scrollbars */
.table-responsive-wrapper,
.deliverables-stack-list,
.activity-timeline-feed {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.table-responsive-wrapper::-webkit-scrollbar,
.deliverables-stack-list::-webkit-scrollbar,
.activity-timeline-feed::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.table-responsive-wrapper::-webkit-scrollbar-track,
.deliverables-stack-list::-webkit-scrollbar-track,
.activity-timeline-feed::-webkit-scrollbar-track {
    background: transparent;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb,
.deliverables-stack-list::-webkit-scrollbar-thumb,
.activity-timeline-feed::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover,
.deliverables-stack-list::-webkit-scrollbar-thumb:hover,
.activity-timeline-feed::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
}

/* Side Widgets Column (Right Column) */
.side-widgets-column {
    display: flex;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    min-height: 0;
}

/* Deliverables Card */
.deliverables-card {
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    max-height: 220px;
}

.deliverables-stack-list {
    padding: 8px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    max-height: 165px;
    overflow-y: auto;
}

.deliverable-item-card {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    background: #fafbfc;
    border: 1px solid var(--surface-border-subtle);
    border-radius: var(--radius-sm);
    transition: all 0.2s ease;
}

.deliverable-item-card:hover {
    background: #ffffff;
    border-color: #cbd5e1;
    box-shadow: var(--shadow-subtle);
    transform: translateX(2px);
}

.date-calendar-box {
    width: 32px;
    height: 34px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.box-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
    border: 1px solid var(--color-emerald-border);
}

.box-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
    border: 1px solid var(--color-amber-border);
}

.box-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
    border: 1px solid var(--color-purple-border);
}

.cal-day {
    font-family: var(--font-heading);
    font-size: 12.5px;
    font-weight: 800;
    line-height: 1;
}

.cal-month {
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.3px;
    margin-top: 1px;
}

.deliverable-content {
    flex: 1 1;
    min-width: 0;
}

.deliverable-name {
    font-size: 11.5px;
    font-weight: 700;
    color: var(--text-heading);
    margin: 0 0 2px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.deliverable-badges {
    display: flex;
    align-items: center;
    gap: 5px;
}

.status-micro-pill {
    font-size: 9px;
    font-weight: 700;
    padding: 1px 4px;
    border-radius: var(--radius-full);
}

.micro-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
}

.micro-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
}

.micro-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
}

.deliverable-due-text {
    font-size: 10px;
    color: var(--text-light);
}

.empty-deliverables-box,
.empty-activity-box {
    padding: 18px;
    text-align: center;
    color: var(--text-light);
    font-size: 11.5px;
}

.empty-deliverables-box i,
.empty-activity-box i {
    font-size: 20px;
    display: block;
    margin-bottom: 4px;
}

/* Activity Feed Card */
.activity-feed-card {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-height: 0;
}

.activity-timeline-feed {
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    gap: 4px;
}

.activity-timeline-node {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    flex: 1 1;
    min-height: 36px;
    padding: 2px 0;
}

.activity-timeline-node:not(:last-child)::after {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    height: 100%;
    width: 2px;
    background-color: var(--surface-subtle);
    z-index: 1;
}

.timeline-indicator-icon {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    flex-shrink: 0;
    position: relative;
    z-index: 2;
}

.node-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
    border: 1px solid var(--color-emerald-border);
}

.node-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
    border: 1px solid var(--color-amber-border);
}

.node-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
    border: 1px solid var(--color-purple-border);
}

.node-sky {
    background: var(--color-sky-light);
    color: var(--color-sky);
    border: 1px solid var(--color-sky-border);
}

.timeline-node-body {
    flex: 1 1;
    min-width: 0;
    padding-top: 1px;
}

.activity-task-title {
    font-size: 11.5px;
    font-weight: 600;
    color: var(--text-heading);
    margin-bottom: 2px;
    line-height: 1.25;
}

.activity-meta-line {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: var(--text-muted);
    flex-wrap: wrap;
}

.activity-status-tag {
    font-size: 8.5px;
    font-weight: 700;
    padding: 1px 4px;
    border-radius: 3px;
}

.tag-green {
    background: var(--color-emerald-light);
    color: var(--color-emerald);
}

.tag-amber {
    background: var(--color-amber-light);
    color: var(--color-amber);
}

.tag-purple {
    background: var(--color-purple-light);
    color: var(--color-purple);
}

.tag-sky {
    background: var(--color-sky-light);
    color: var(--color-sky);
}

.activity-assignee strong {
    color: var(--text-body);
}

.activity-timestamp {
    color: var(--text-light);
}

/* ==========================================================================
   RESPONSIVE
   ========================================================================== */

@media (max-width: 1400px) {
    .stats-kpi-grid {
        grid-template-columns: repeat(5, 1fr);
    }

    .bottom-dashboard-grid {
        grid-template-columns: 1.6fr 1fr 1.1fr;
    }
}

@media (max-width: 1200px) {
    .stats-kpi-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .analytics-spotlight-grid {
        grid-template-columns: 1fr;
    }

    .bottom-dashboard-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 992px) {
    .btn-mobile-sidebar-toggle {
        display: inline-flex;
    }

    .btn-sidebar-close-mobile {
        display: inline-flex;
    }

    .sidebar-mobile-backdrop {
        display: block;
        position: fixed;
        inset: 0;
        background: rgba(15, 23, 42, 0.5);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        z-index: 998;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.25s ease;
    }

    body.sidebar-mobile-open .sidebar-mobile-backdrop {
        opacity: 1;
        pointer-events: auto;
    }

    .dash-sidebar {
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: 270px;
        max-width: 84vw;
        z-index: 999;
        transform: translateX(-100%);
        transition: transform 0.28s cubic-bezier(0.16, 1, 0.3, 1);
        box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
        background: #ffffff;
        padding: 16px;
        overflow-y: auto;
    }

    body.sidebar-mobile-open .dash-sidebar {
        transform: translateX(0);
    }

    .dash-sidebar .sidebar-logo {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0 14px 0;
        margin-bottom: 14px;
        border-bottom: 1px solid var(--surface-border-subtle);
    }

    .dash-sidebar .sidebar-logo img {
        display: block !important;
        height: 28px;
        max-width: 140px;
        object-fit: contain;
    }

    .dash-sidebar .menu-item-link span,
    .dash-sidebar .sidebar-help-card,
    .dash-sidebar .sidebar-footer {
        display: block !important;
    }

    .dash-sidebar .menu-item-link {
        justify-content: flex-start !important;
        padding: 9px 12px !important;
    }

    .dash-main {
        margin-left: 0 !important;
        width: 100% !important;
        padding: 12px 14px 24px 14px !important;
    }

    .stats-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .support-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }
}

@media (max-width: 768px) {
    .dashboard-hero-bar {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 14px;
    }

    .hero-welcome-info {
        width: 100%;
    }

    .hero-title-row {
        flex-wrap: wrap;
        gap: 6px;
    }

    .hero-controls {
        width: 100%;
        flex-wrap: wrap;
        gap: 8px;
    }

    .project-dropdown-wrapper {
        flex: 1 1;
        min-width: 140px;
    }

    .btn-create-ticket-primary {
        flex: 1 1;
        min-width: 140px;
        justify-content: center;
    }

    .projects-main-card {
        height: auto;
        min-height: calc(100vh - 120px);
    }
}

@media (max-width: 576px) {
    .dash-header {
        margin-bottom: 10px;
        padding-bottom: 8px;
    }

    .header-page-title h3 {
        font-size: 15px;
    }

    .user-profile-details {
        display: none;
    }

    .user-profile-card {
        padding: 0;
        background: transparent;
        border: none;
        box-shadow: none;
    }

    .logout-btn-styled span {
        display: none;
    }

    .logout-btn-styled {
        padding: 6px 8px;
        border-radius: 6px;
    }

    .stats-kpi-grid {
        grid-template-columns: 1fr;
    }

    .support-kpi-grid {
        grid-template-columns: 1fr;
    }

    .support-kpi-card {
        padding: 12px;
    }

    .support-kpi-val {
        font-size: 18px;
    }

    .project-select-container {
        width: 100%;
    }

    .project-meta-grid {
        grid-template-columns: 1fr;
    }

    .card-header-actions {
        width: 100%;
        gap: 6px;
    }

    .support-search-wrap {
        width: 100% !important;
    }

    .custom-popover-dropdown {
        flex: 1 1;
        min-width: 110px;
    }

    .custom-dropdown-btn {
        width: 100%;
    }

    .modal-dialog {
        margin: 8px;
    }
}

/* ==========================================================================
   RIGHT-TO-LEFT NOTIFICATION DRAWER / SLIDE-OVER MODAL
   ========================================================================== */

.notif-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(15, 23, 42, 0.45);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    z-index: 1040;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s ease, visibility 0.25s ease;
}

.notif-backdrop.open {
    opacity: 1;
    visibility: visible;
}

.notif-drawer-modal {
    position: fixed;
    top: 0;
    right: 0;
    width: 490px;
    max-width: 92vw;
    height: 100vh;
    background: #ffffff;
    box-shadow: -8px 0 40px -2px rgba(15, 23, 42, 0.2);
    z-index: 1050;
    display: flex;
    flex-direction: column;
    transform: translateX(100%);
    transition: transform 0.32s cubic-bezier(0.16, 1, 0.3, 1);
}

.notif-drawer-modal.open {
    transform: translateX(0);
}

.notif-drawer-header {
    padding: 20px 22px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
}

.notif-header-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.notif-header-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.notif-header-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 17px;
    font-weight: 800;
    color: #0f172a;
    margin: 0;
    letter-spacing: -0.3px;
}

.notif-unread-count {
    font-size: 11px;
    font-weight: 700;
    background: #ecfdf5;
    color: #065f46;
    border: 1px solid #a7f3d0;
    padding: 2px 8px;
    border-radius: 9999px;
}

.notif-close-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.notif-close-btn:hover {
    background: #eef2ff;
    color: #4f46e5;
    border-color: #c7d2fe;
}

.notif-drawer-tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.notif-tab-pills {
    display: flex;
    background: #e2e8f0;
    padding: 3px;
    border-radius: 8px;
    gap: 2px;
}

.notif-tab-btn {
    border: none;
    background: transparent;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
}

.notif-tab-btn.active {
    background: #ffffff;
    color: #4f46e5;
    font-weight: 700;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.notif-mark-read-btn {
    border: none;
    background: transparent;
    font-size: 11.5px;
    font-weight: 600;
    color: #4f46e5;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    transition: color 0.15s ease;
}

.notif-mark-read-btn:hover {
    color: #3730a3;
    text-decoration: underline;
}

.notif-drawer-body {
    flex: 1 1;
    overflow-y: auto;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.notif-item-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px;
    display: flex;
    gap: 12px;
    align-items: flex-start;
    position: relative;
    transition: all 0.2s ease;
    cursor: pointer;
}

.notif-item-card:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}

.notif-item-card.unread {
    background: #faf5ff;
    border-color: #e9d5ff;
}

.notif-item-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;
}

.notif-icon-milestone { background: #ecfdf5; color: #10b981; }
.notif-icon-task      { background: #eef2ff; color: #4f46e5; }
.notif-icon-doc       { background: #fff1f2; color: #e11d48; }
.notif-icon-system    { background: #f5f3ff; color: #7c3aed; }
.notif-icon-support   { background: #fffbeb; color: #d97706; }

.notif-item-content {
    flex: 1 1;
    min-width: 0;
}

.notif-item-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 3px;
}

.notif-item-title {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.3;
}

.notif-dot-unread {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #8b5cf6;
    flex-shrink: 0;
}

.notif-item-desc {
    font-size: 12px;
    color: #64748b;
    margin: 0 0 6px 0;
    line-height: 1.4;
}

.notif-item-time {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
}

.notif-dismiss-btn {
    border: none;
    background: transparent;
    color: #94a3b8;
    font-size: 12px;
    cursor: pointer;
    padding: 2px 4px;
    border-radius: 4px;
    transition: all 0.15s ease;
}

.notif-dismiss-btn:hover {
    color: #e11d48;
    background: #fff1f2;
}

.notif-drawer-footer {
    padding: 14px 20px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #ffffff;
}

.notif-footer-action {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-decoration: none;
    border: none;
    background: transparent;
    cursor: pointer;
    transition: color 0.15s ease;
}

.notif-footer-action:hover {
    color: #0f172a;
}

.notif-footer-action.danger:hover {
    color: #e11d48;
}

/* Empty notifications */
.notif-empty-state {
    padding: 60px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.notif-empty-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    margin-bottom: 14px;
}

.notif-empty-title {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 4px;
}

.notif-empty-desc {
    font-size: 12.5px;
    color: #94a3b8;
    max-width: 260px;
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAI/E;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,8BAA8B;IAC9B,6CAA6C;;IAE7C,wBAAwB;IACxB,8BAA8B;IAC9B,+BAA+B;;IAE/B,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;;IAE7B,oBAAoB;IACpB,0BAA0B;IAC1B,2BAA2B;;IAE3B,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;;IAE9B,wBAAwB;IACxB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;IACzB,gCAAgC;;IAEhC,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;;IAErB,wBAAwB;IACxB,oFAAoF;IACpF,4FAA4F;IAC5F,+FAA+F;;IAE/F,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,kFAAkF;IAClF,mEAAmE;AACvE;;AAEA;IACI,mCAAmC;IACnC,6BAA6B;IAC7B,uBAAuB;IACvB,SAAS;IACT,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mCAAmC;IACnC,WAAW;AACf;;AAEA;;+EAE+E;;AAE/E;IACI,YAAY;IACZ,yBAAyB;IACzB,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qDAAqD;IACrD,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,+BAA+B;IAC/B,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;AAChD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,UAAU;IACV,0BAA0B;IAC1B,kEAAkE;AACtE;;AAEA;IACI,6DAA6D;IAC7D,+BAA+B;IAC/B,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;+EAE+E;;AAE/E;IACI,SAAO;IACP,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,qDAAqD;IACrD,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,uCAAuC;IACvC,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,uCAAuC;IACvC,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,iCAAiC;IACjC,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kEAAkE;IAClE,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,8CAA8C;IAC9C,4CAA4C;AAChD;;AAEA;IACI;QACI,sBAAsB;QACtB,2CAA2C;IAC/C;;IAEA;QACI,mBAAmB;QACnB,2CAA2C;IAC/C;;IAEA;QACI,sBAAsB;QACtB,yCAAyC;IAC7C;AACJ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,gCAAgC;IAChC,eAAe;IACf,kDAAkD;IAClD,aAAa;AACjB;;AAEA;;IAEI,kCAAkC;IAClC,+CAA+C;IAC/C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,iDAAiD;IACjD,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,2FAA2F;IAC3F,gBAAgB;IAChB,gEAAgE;IAChE,YAAY;AAChB;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,qDAAqD;IACrD,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;IAEI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;+EAE+E;;AAE/E;IACI,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,uCAAuC;IACvC,SAAS;IACT,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,sCAAsC;IACtC,6CAA6C;IAC7C,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,oDAAoD;AACxD;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,QAAQ;IACR,SAAO;IACP,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oCAAoC;IACpC,2CAA2C;IAC3C,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;;+EAE+E;;AAE/E;IACI,SAAO;IACP,aAAa;IACb,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qDAAqD;IACrD,uCAAuC;IACvC,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,WAAW;IACX,uCAAuC;IACvC,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,sCAAsC;IACtC,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;;;IAGI,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;;;IAGI,UAAU;IACV,WAAW;AACf;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;IAGI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,aAAa;AACjB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,8CAA8C;IAC9C,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,UAAU;IACV,uCAAuC;IACvC,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;+EAE+E;;AAE/E;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,QAAQ;QACR,iCAAiC;QACjC,0BAA0B;QAC1B,kCAAkC;QAClC,YAAY;QACZ,UAAU;QACV,oBAAoB;QACpB,8BAA8B;IAClC;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,OAAO;QACP,MAAM;QACN,SAAS;QACT,YAAY;QACZ,eAAe;QACf,YAAY;QACZ,4BAA4B;QAC5B,yDAAyD;QACzD,oDAAoD;QACpD,mBAAmB;QACnB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,mBAAmB;QACnB,mBAAmB;QACnB,qDAAqD;IACzD;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;;QAGI,yBAAyB;IAC7B;;IAEA;QACI,sCAAsC;QACtC,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;QACtB,uCAAuC;IAC3C;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,SAAO;QACP,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,uBAAuB;QACvB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,QAAQ;IACZ;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;;+EAE+E;;AAE/E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,0BAA0B;IAC1B,kCAAkC;IAClC,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kDAAkD;IAClD,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,yDAAyD;AAC7D;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb","sourcesContent":["/* ==========================================================================\n   ENTERPRISE CLIENT DASHBOARD DESIGN SYSTEM\n   Theme: Precision Clean SaaS Hybrid (Linear / Stripe / Vercel style)\n   ========================================================================== */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n:root {\n    /* Brand & Accent Tokens */\n    --brand-primary: #4f46e5;\n    --brand-primary-light: #eef2ff;\n    --brand-primary-glow: rgba(79, 70, 229, 0.18);\n\n    --color-emerald: #10b981;\n    --color-emerald-light: #ecfdf5;\n    --color-emerald-border: #a7f3d0;\n\n    --color-amber: #f59e0b;\n    --color-amber-light: #fffbeb;\n    --color-amber-border: #fde68a;\n\n    --color-sky: #0284c7;\n    --color-sky-light: #f0f9ff;\n    --color-sky-border: #bae6fd;\n\n    --color-purple: #8b5cf6;\n    --color-purple-light: #f5f3ff;\n    --color-purple-border: #ddd6fe;\n\n    /* Neutrals & Surfaces */\n    --surface-bg: #f8fafc;\n    --surface-card: #ffffff;\n    --surface-subtle: #f1f5f9;\n    --surface-border: #e2e8f0;\n    --surface-border-subtle: #f1f5f9;\n\n    /* Typography Colors */\n    --text-heading: #0f172a;\n    --text-body: #334155;\n    --text-muted: #64748b;\n    --text-light: #94a3b8;\n\n    /* Elevation & Shadows */\n    --shadow-subtle: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.04);\n    --shadow-card: 0 4px 16px -2px rgba(15, 23, 42, 0.04), 0 2px 6px -1px rgba(15, 23, 42, 0.02);\n    --shadow-hover: 0 12px 28px -4px rgba(15, 23, 42, 0.08), 0 4px 12px -2px rgba(15, 23, 42, 0.03);\n\n    /* Radius & Font */\n    --radius-sm: 8px;\n    --radius-md: 12px;\n    --radius-lg: 16px;\n    --radius-full: 9999px;\n    --font-heading: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;\n    --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\nbody {\n    background-color: var(--surface-bg);\n    font-family: var(--font-body);\n    color: var(--text-body);\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n}\n\n.dashboard-wrapper {\n    display: flex;\n    min-height: 100vh;\n    background-color: var(--surface-bg);\n    width: 100%;\n}\n\n/* ==========================================================================\n   SIDEBAR\n   ========================================================================== */\n\n.dash-sidebar {\n    width: 240px;\n    background-color: #ffffff;\n    border-right: 1px solid var(--surface-border);\n    display: flex;\n    flex-direction: column;\n    padding: 20px 14px;\n    position: fixed;\n    height: 100vh;\n    z-index: 100;\n}\n\n.sidebar-logo {\n    display: flex;\n    align-items: center;\n    padding: 0 6px 18px 6px;\n    border-bottom: 1px solid var(--surface-border-subtle);\n    margin-bottom: 16px;\n}\n\n.sidebar-logo img {\n    height: 30px;\n    max-width: 150px;\n    object-fit: contain;\n}\n\n.sidebar-menu {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.menu-item-link {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 9px 12px;\n    border-radius: var(--radius-sm);\n    color: var(--text-muted);\n    text-decoration: none;\n    font-size: 13px;\n    font-weight: 500;\n    transition: all 0.2s ease;\n    position: relative;\n}\n\n.menu-item-link i {\n    font-size: 15px;\n    color: var(--text-light);\n    transition: color 0.2s ease;\n}\n\n.menu-item-link:hover {\n    color: var(--brand-primary);\n    background-color: var(--brand-primary-light);\n}\n\n.menu-item-link:hover i {\n    color: var(--brand-primary);\n}\n\n.menu-item-link.active {\n    color: var(--brand-primary);\n    background-color: var(--brand-primary-light);\n    font-weight: 600;\n}\n\n.menu-item-link.active i {\n    color: var(--brand-primary);\n}\n\n.menu-item-link.active::before {\n    content: '';\n    position: absolute;\n    left: -14px;\n    top: 6px;\n    bottom: 6px;\n    width: 4px;\n    border-radius: 0 4px 4px 0;\n    background: linear-gradient(180deg, var(--brand-primary), #6366f1);\n}\n\n.sidebar-help-card {\n    background: linear-gradient(135deg, #f8f9ff 0%, #eef2ff 100%);\n    border-radius: var(--radius-md);\n    padding: 14px;\n    margin-top: auto;\n    text-align: center;\n    border: 1px solid var(--color-purple-border);\n}\n\n.help-icon-wrapper {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: #ffffff;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--brand-primary);\n    font-size: 16px;\n    box-shadow: 0 2px 8px rgba(79, 70, 229, 0.15);\n    margin-bottom: 8px;\n}\n\n.sidebar-help-card h6 {\n    font-family: var(--font-heading);\n    font-size: 13.5px;\n    font-weight: 700;\n    color: var(--text-heading);\n    margin-bottom: 3px;\n}\n\n.sidebar-help-card p {\n    font-size: 11.5px;\n    color: var(--text-muted);\n    margin-bottom: 10px;\n    line-height: 1.35;\n}\n\n.btn-contact-support {\n    background: var(--brand-primary);\n    color: #ffffff !important;\n    font-size: 11.5px;\n    font-weight: 600;\n    padding: 7px 10px;\n    border-radius: var(--radius-sm);\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.2);\n}\n\n.btn-contact-support:hover {\n    background: #4338ca;\n    transform: translateY(-1px);\n}\n\n.sidebar-footer {\n    font-size: 10.5px;\n    color: var(--text-light);\n    text-align: center;\n    margin-top: 12px;\n    line-height: 1.3;\n}\n\n/* ==========================================================================\n   MAIN DASHBOARD WRAPPER & HEADER\n   ========================================================================== */\n\n.dash-main {\n    flex: 1;\n    margin-left: 240px;\n    padding: 12px 20px 14px 20px;\n    width: calc(100% - 240px);\n    max-width: 100%;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.dash-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 8px;\n    border-bottom: 1px solid var(--surface-border-subtle);\n    margin-bottom: 12px;\n}\n\n.header-left-group {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.btn-mobile-sidebar-toggle {\n    display: none;\n    width: 34px;\n    height: 34px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--surface-border);\n    background: #ffffff;\n    color: var(--text-heading);\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.btn-mobile-sidebar-toggle:hover {\n    background: var(--surface-subtle);\n    border-color: #cbd5e1;\n    color: var(--brand-primary);\n}\n\n.btn-sidebar-close-mobile {\n    display: none;\n    width: 30px;\n    height: 30px;\n    border-radius: 6px;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #64748b;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    cursor: pointer;\n    margin-left: auto;\n    transition: all 0.2s ease;\n}\n\n.btn-sidebar-close-mobile:hover {\n    background: #fee2e2;\n    color: #ef4444;\n    border-color: #fecaca;\n}\n\n.sidebar-mobile-backdrop {\n    display: none;\n}\n\n.header-page-title h3 {\n    font-family: var(--font-heading);\n    font-size: 17px;\n    font-weight: 700;\n    color: var(--text-heading);\n    margin: 0;\n    letter-spacing: -0.3px;\n}\n\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.notification-btn {\n    width: 34px;\n    height: 34px;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--surface-border);\n    background: #ffffff;\n    color: var(--text-muted);\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13.5px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.notification-btn:hover {\n    background: var(--surface-subtle);\n    color: var(--brand-primary);\n    border-color: #cbd5e1;\n    transform: translateY(-1px);\n}\n\n.notification-badge {\n    position: absolute;\n    top: 7px;\n    right: 7px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: var(--color-amber);\n    border: 1.5px solid #ffffff;\n}\n\n.user-profile-card {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    height: 34px;\n    padding: 2px 10px 2px 3px;\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-full);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n    transition: all 0.2s ease;\n}\n\n.user-profile-card:hover {\n    border-color: #c7d2fe;\n    box-shadow: 0 2px 6px rgba(99, 102, 241, 0.1);\n    transform: translateY(-1px);\n}\n\n.user-avatar-circle {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, var(--brand-primary), #8b5cf6);\n    color: #ffffff;\n    font-family: var(--font-heading);\n    font-size: 10.5px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 4px rgba(99, 102, 241, 0.25);\n    flex-shrink: 0;\n}\n\n.user-profile-details {\n    display: flex;\n    flex-direction: column;\n    line-height: 1.1;\n    justify-content: center;\n}\n\n.user-profile-name {\n    font-family: var(--font-heading);\n    font-size: 12.5px;\n    font-weight: 700;\n    color: var(--text-heading);\n    letter-spacing: -0.2px;\n    white-space: nowrap;\n    padding-right: 4px;\n}\n\n.user-profile-role {\n    font-size: 9.5px;\n    color: var(--brand-primary);\n    font-weight: 600;\n    text-transform: capitalize;\n}\n\n.logout-btn-styled {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    height: 34px;\n    padding: 0 10px;\n    border-radius: var(--radius-sm);\n    border: 1px solid #fee2e2;\n    background: #fff5f5;\n    color: #ef4444;\n    font-family: var(--font-heading);\n    font-size: 11.5px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px rgba(239, 68, 68, 0.05);\n}\n\n.logout-btn-styled:hover {\n    background: #fee2e2;\n    color: #dc2626;\n    border-color: #fca5a5;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 5px rgba(239, 68, 68, 0.12);\n}\n\n/* ==========================================================================\n   HERO BAR & CUSTOM PROJECT DROPDOWN\n   ========================================================================== */\n\n.dashboard-hero-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    gap: 12px;\n    flex-wrap: wrap;\n    position: relative;\n    z-index: 30;\n}\n\n.hero-welcome-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.hero-title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.hero-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 2px 8px;\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-full);\n    font-size: 10px;\n    font-weight: 600;\n    color: var(--brand-primary);\n    width: fit-content;\n    box-shadow: var(--shadow-subtle);\n}\n\n.pulse-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background-color: var(--color-emerald);\n    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.25);\n    animation: pulseGlow 2s infinite ease-in-out;\n}\n\n@keyframes pulseGlow {\n    0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);\n    }\n\n    70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 5px rgba(16, 185, 129, 0);\n    }\n\n    100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n    }\n}\n\n.hero-title {\n    font-family: var(--font-heading);\n    font-size: 18px;\n    font-weight: 800;\n    color: var(--text-heading);\n    margin: 0;\n    letter-spacing: -0.3px;\n}\n\n.hero-subtitle {\n    font-size: 11.5px;\n    color: var(--text-muted);\n    margin: 0;\n}\n\n.hero-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n}\n\n/* Sleek Floating Project Dropdown */\n.project-dropdown-wrapper {\n    position: relative;\n    min-width: 200px;\n}\n\n.project-dropdown-trigger {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    width: 100%;\n    padding: 7px 12px;\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-subtle);\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    outline: none;\n}\n\n.project-dropdown-trigger:hover,\n.project-dropdown-trigger.active {\n    border-color: var(--brand-primary);\n    box-shadow: 0 0 0 3px var(--brand-primary-glow);\n    background: #ffffff;\n}\n\n.project-trigger-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n}\n\n.project-trigger-icon {\n    font-size: 13px;\n    color: var(--brand-primary);\n    flex-shrink: 0;\n}\n\n.project-trigger-name {\n    font-family: var(--font-heading);\n    font-size: 12.5px;\n    font-weight: 700;\n    color: var(--text-heading);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 170px;\n}\n\n.project-trigger-chevron {\n    font-size: 10.5px;\n    color: var(--text-light);\n    transition: transform 0.25s ease, color 0.2s ease;\n    flex-shrink: 0;\n}\n\n.project-trigger-chevron.open {\n    transform: rotate(180deg);\n    color: var(--brand-primary);\n}\n\n.project-dropdown-menu {\n    position: absolute;\n    top: calc(100% + 6px);\n    right: 0;\n    min-width: 240px;\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-md);\n    box-shadow: 0 12px 28px -4px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.06);\n    overflow: hidden;\n    animation: dropdownFadeSlide 0.18s cubic-bezier(0.16, 1, 0.3, 1);\n    z-index: 100;\n}\n\n@keyframes dropdownFadeSlide {\n    from {\n        opacity: 0;\n        transform: translateY(-6px) scale(0.97);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n.project-dropdown-header {\n    padding: 8px 12px;\n    background: #fafbfc;\n    border-bottom: 1px solid var(--surface-border-subtle);\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--text-muted);\n}\n\n.project-dropdown-list {\n    padding: 4px;\n    max-height: 220px;\n    overflow-y: auto;\n}\n\n.project-dropdown-item {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n    padding: 7px 10px;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.project-dropdown-item:hover {\n    background: var(--brand-primary-light);\n}\n\n.project-dropdown-item.selected {\n    background: #eef2ff;\n}\n\n.item-icon-wrap {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    background: #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    color: var(--text-muted);\n    flex-shrink: 0;\n    transition: all 0.15s ease;\n}\n\n.project-dropdown-item:hover .item-icon-wrap,\n.project-dropdown-item.selected .item-icon-wrap {\n    background: var(--brand-primary);\n    color: #ffffff;\n}\n\n.item-name {\n    flex: 1;\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-heading);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.project-dropdown-item.selected .item-name {\n    color: var(--brand-primary);\n    font-weight: 700;\n}\n\n.item-check {\n    font-size: 13px;\n    color: var(--brand-primary);\n    font-weight: 800;\n}\n\n.project-dropdown-empty {\n    padding: 12px;\n    text-align: center;\n    color: var(--text-muted);\n    font-size: 11.5px;\n}\n\n/* ==========================================================================\n   KPI STAT CARDS (TOP 5 CARDS)\n   ========================================================================== */\n\n.stats-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 10px;\n    margin-bottom: 12px;\n}\n\n.kpi-card {\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-md);\n    padding: 9px 12px 8px 12px;\n    box-shadow: var(--shadow-card);\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n}\n\n.kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-hover);\n    border-color: #cbd5e1;\n}\n\n.kpi-card::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n}\n\n.kpi-card-purple::after {\n    background: linear-gradient(90deg, #8b5cf6, #a855f7);\n}\n\n.kpi-card-green::after {\n    background: linear-gradient(90deg, #10b981, #34d399);\n}\n\n.kpi-card-amber::after {\n    background: linear-gradient(90deg, #f59e0b, #fbbf24);\n}\n\n.kpi-card-sky::after {\n    background: linear-gradient(90deg, #0284c7, #38bdf8);\n}\n\n.kpi-card-indigo::after {\n    background: linear-gradient(90deg, #4f46e5, #6366f1);\n}\n\n.kpi-card-header-line {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n\n.kpi-title-text {\n    font-size: 10.5px;\n    font-weight: 700;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.kpi-icon-pill {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n}\n\n.icon-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n}\n\n.icon-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n}\n\n.icon-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n}\n\n.icon-sky {\n    background: var(--color-sky-light);\n    color: var(--color-sky);\n}\n\n.icon-indigo {\n    background: var(--brand-primary-light);\n    color: var(--brand-primary);\n}\n\n.kpi-value-container {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    margin-bottom: 5px;\n}\n\n.kpi-big-number {\n    font-family: var(--font-heading);\n    font-size: 20px;\n    font-weight: 800;\n    color: var(--text-heading);\n    line-height: 1;\n    letter-spacing: -0.4px;\n}\n\n.kpi-tag-chip {\n    font-size: 9.5px;\n    font-weight: 700;\n    padding: 1px 6px;\n    border-radius: var(--radius-full);\n}\n\n.tag-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n    border: 1px solid var(--color-purple-border);\n}\n\n.tag-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n    border: 1px solid var(--color-emerald-border);\n}\n\n.tag-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n    border: 1px solid var(--color-amber-border);\n}\n\n.tag-sky {\n    background: var(--color-sky-light);\n    color: var(--color-sky);\n    border: 1px solid var(--color-sky-border);\n}\n\n.tag-indigo {\n    background: var(--brand-primary-light);\n    color: var(--brand-primary);\n    border: 1px solid #c7d2fe;\n}\n\n.kpi-mini-track {\n    height: 3px;\n    background-color: var(--surface-subtle);\n    border-radius: var(--radius-full);\n    overflow: hidden;\n    margin-bottom: 4px;\n}\n\n.kpi-mini-fill {\n    height: 100%;\n    border-radius: var(--radius-full);\n    transition: width 0.6s ease;\n}\n\n.bg-purple {\n    background-color: var(--color-purple);\n}\n\n.bg-green {\n    background-color: var(--color-emerald);\n}\n\n.bg-amber {\n    background-color: var(--color-amber);\n}\n\n.bg-sky {\n    background-color: var(--color-sky);\n}\n\n.bg-indigo {\n    background-color: var(--brand-primary);\n}\n\n.kpi-caption {\n    font-size: 10px;\n    color: var(--text-muted);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ==========================================================================\n   PRO CARDS\n   ========================================================================== */\n\n.pro-card {\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-card);\n    transition: all 0.2s ease;\n}\n\n.pro-card:hover {\n    box-shadow: var(--shadow-hover);\n    border-color: #cbd5e1;\n}\n\n.pro-card-header {\n    padding: 9px 14px;\n    border-bottom: 1px solid var(--surface-border-subtle);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.card-title-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.card-title-icon {\n    width: 26px;\n    height: 26px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n}\n\n.indigo-soft {\n    background: var(--brand-primary-light);\n    color: var(--brand-primary);\n}\n\n.green-soft {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n}\n\n.amber-soft {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n}\n\n.sky-soft {\n    background: var(--color-sky-light);\n    color: var(--color-sky);\n}\n\n.purple-soft {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n}\n\n.pro-card-title {\n    font-family: var(--font-heading);\n    font-size: 13px;\n    font-weight: 700;\n    color: var(--text-heading);\n    margin: 0;\n    line-height: 1.2;\n}\n\n.pro-card-subtitle {\n    font-size: 10.5px;\n    color: var(--text-muted);\n}\n\n.pro-view-all-btn {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--brand-primary);\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    transition: all 0.2s ease;\n}\n\n.pro-view-all-btn:hover {\n    color: #4338ca;\n    transform: translateX(2px);\n}\n\n/* ==========================================================================\n   MIDDLE ROW (3 CARDS)\n   ========================================================================== */\n\n.analytics-spotlight-grid {\n    display: grid;\n    grid-template-columns: 1.2fr 1fr 1.15fr;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n/* Card 1: Project Progress */\n.project-progress-card .overall-progress-body {\n    padding: 10px 14px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.live-status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10.5px;\n    font-weight: 700;\n    color: var(--color-emerald);\n    background: var(--color-emerald-light);\n    border: 1px solid var(--color-emerald-border);\n    padding: 2px 7px;\n    border-radius: var(--radius-full);\n}\n\n.status-indicator-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background-color: var(--color-emerald);\n}\n\n.progress-metric-display {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.big-metric-percent {\n    font-family: var(--font-heading);\n    font-size: 26px;\n    font-weight: 800;\n    color: var(--text-heading);\n    letter-spacing: -0.6px;\n    line-height: 1;\n}\n\n.percent-symbol {\n    font-size: 16px;\n    font-weight: 700;\n    color: var(--brand-primary);\n    margin-left: 2px;\n}\n\n.metric-status-text {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--text-muted);\n}\n\n.pro-progress-bar-container {\n    height: 7px;\n    background-color: var(--surface-subtle);\n    border-radius: var(--radius-full);\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n.pro-progress-bar-fill {\n    height: 100%;\n    border-radius: var(--radius-full);\n    transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.gradient-primary {\n    background: linear-gradient(90deg, #6366f1 0%, #4f46e5 100%);\n}\n\n.project-meta-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 8px;\n    padding-top: 8px;\n    border-top: 1px solid var(--surface-border-subtle);\n}\n\n.meta-box {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.meta-box-icon {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    background: var(--surface-subtle);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-muted);\n    font-size: 11px;\n    flex-shrink: 0;\n}\n\n.meta-box-content {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.meta-box-label {\n    font-size: 9.5px;\n    font-weight: 600;\n    color: var(--text-light);\n    text-transform: uppercase;\n}\n\n.meta-box-value {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-heading);\n}\n\n/* Card 2: Donut Chart */\n.milestone-distribution-card {\n    display: flex;\n    flex-direction: column;\n}\n\n.donut-chart-layout {\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex: 1;\n    justify-content: center;\n}\n\n.donut-visual-container {\n    position: relative;\n    width: 102px;\n    height: 102px;\n    flex-shrink: 0;\n}\n\n.donut-svg-modern {\n    transform: rotate(-90deg);\n    transform-origin: 48px 48px;\n    width: 102px;\n    height: 102px;\n}\n\n.donut-segment {\n    transition: stroke-dasharray 0.6s ease;\n}\n\n.donut-center-badge {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    pointer-events: none;\n}\n\n.donut-center-count {\n    font-family: var(--font-heading);\n    font-size: 19px;\n    font-weight: 800;\n    color: var(--text-heading);\n    line-height: 1;\n}\n\n.donut-center-tag {\n    font-size: 9px;\n    font-weight: 700;\n    color: var(--text-light);\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n.donut-legend-modern {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    gap: 8px;\n    flex: 1;\n    height: 100%;\n    max-height: 104px;\n}\n\n.legend-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 3px 0;\n}\n\n.legend-title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.legend-indicator {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    flex-shrink: 0;\n}\n\n.dot-green {\n    background-color: var(--color-emerald);\n}\n\n.dot-amber {\n    background-color: var(--color-amber);\n}\n\n.dot-purple {\n    background-color: var(--color-purple);\n}\n\n.legend-name {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: var(--text-heading);\n}\n\n.legend-stats-wrap {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.legend-count {\n    font-family: var(--font-heading);\n    font-size: 12.5px;\n    font-weight: 800;\n    color: var(--text-heading);\n    min-width: 10px;\n    text-align: right;\n}\n\n.legend-percent-pill {\n    font-size: 9.5px;\n    font-weight: 700;\n    padding: 2px 6px;\n    border-radius: var(--radius-full);\n    min-width: 32px;\n    text-align: center;\n}\n\n.pill-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n    border: 1px solid var(--color-emerald-border);\n}\n\n.pill-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n    border: 1px solid var(--color-amber-border);\n}\n\n.pill-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n    border: 1px solid var(--color-purple-border);\n}\n\n/* Card 3: Current Milestone Spotlight */\n.current-milestone-body {\n    padding: 10px 14px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.current-status-badge {\n    font-size: 10px;\n    font-weight: 700;\n    color: var(--color-amber);\n    background: var(--color-amber-light);\n    border: 1px solid var(--color-amber-border);\n    padding: 1px 6px;\n    border-radius: var(--radius-full);\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n}\n\n.spotlight-milestone-name {\n    font-family: var(--font-heading);\n    font-size: 15px;\n    font-weight: 800;\n    color: var(--text-heading);\n    margin: 0 0 6px 0;\n    line-height: 1.2;\n}\n\n.spotlight-dates-row {\n    display: flex;\n    gap: 5px;\n    margin-bottom: 8px;\n    flex-wrap: wrap;\n}\n\n.date-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 6px;\n    background: var(--surface-subtle);\n    border-radius: var(--radius-sm);\n    font-size: 10.5px;\n    font-weight: 500;\n    color: var(--text-muted);\n}\n\n.date-chip i {\n    color: var(--brand-primary);\n}\n\n.spotlight-progress-section {\n    margin-bottom: 8px;\n}\n\n.progress-label-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 4px;\n}\n\n.progress-title {\n    font-size: 10.5px;\n    font-weight: 600;\n    color: var(--text-muted);\n}\n\n.progress-val-badge {\n    font-family: var(--font-heading);\n    font-size: 11.5px;\n    font-weight: 800;\n    color: var(--color-amber);\n}\n\n.spotlight-progress-track {\n    height: 6px;\n    background-color: var(--surface-subtle);\n    border-radius: var(--radius-full);\n    overflow: hidden;\n}\n\n.spotlight-progress-fill {\n    height: 100%;\n    border-radius: var(--radius-full);\n    transition: width 0.6s ease;\n}\n\n.gradient-amber {\n    background: linear-gradient(90deg, #f59e0b, #fbbf24);\n}\n\n.spotlight-task-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    padding-top: 8px;\n    border-top: 1px solid var(--surface-border-subtle);\n}\n\n.task-stat-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.stat-icon-pill {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    flex-shrink: 0;\n}\n\n.stat-item-num {\n    font-family: var(--font-heading);\n    font-size: 13px;\n    font-weight: 800;\n    color: var(--text-heading);\n    line-height: 1.1;\n}\n\n.stat-item-label {\n    font-size: 10px;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n/* ==========================================================================\n   BOTTOM SECTION: ROADMAP TABLE + SIDE STACK (PERFECT BOTTOM ALIGNMENT)\n   ========================================================================== */\n\n.bottom-dashboard-grid {\n    flex: 1;\n    min-height: 0;\n    display: grid;\n    grid-template-columns: 1.75fr 1.25fr;\n    gap: 12px;\n    align-items: stretch;\n    margin-bottom: 0;\n}\n\n/* Roadmap Table Card (Left Column) */\n.milestones-table-card {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n}\n\n.table-responsive-wrapper {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.pro-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 11.5px;\n    height: 100%;\n    flex: 1;\n}\n\n.pro-table thead {\n    flex-shrink: 0;\n}\n\n.pro-table thead th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: #fafbfc;\n    color: var(--text-muted);\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    padding: 7px 10px;\n    border-bottom: 1px solid var(--surface-border);\n    white-space: nowrap;\n}\n\n.pro-table tbody {\n    height: 100%;\n}\n\n.pro-table tbody tr {\n    border-bottom: 1px solid var(--surface-border-subtle);\n    transition: background-color 0.15s ease;\n    height: 1%;\n}\n\n.pro-table tbody tr:last-child {\n    border-bottom: none;\n}\n\n.pro-table tbody tr:hover {\n    background-color: #f8faff;\n}\n\n.pro-table tbody td {\n    padding: 6px 10px;\n    vertical-align: middle;\n}\n\n.cell-index {\n    font-family: var(--font-heading);\n    font-weight: 700;\n    color: var(--text-light);\n    font-size: 11px;\n}\n\n.cell-title {\n    font-weight: 600;\n}\n\n.milestone-name-link {\n    color: var(--text-heading);\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    transition: color 0.2s ease;\n}\n\n.milestone-name-link:hover {\n    color: var(--brand-primary);\n}\n\n.milestone-bullet {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background-color: var(--brand-primary);\n    flex-shrink: 0;\n}\n\n.timeline-date-stack {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 11px;\n    color: var(--text-muted);\n    white-space: nowrap;\n}\n\n.date-arrow {\n    color: var(--text-light);\n}\n\n.table-progress-bar-wrap {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.table-bar-track {\n    flex: 1;\n    height: 5px;\n    background-color: var(--surface-subtle);\n    border-radius: var(--radius-full);\n    overflow: hidden;\n    min-width: 45px;\n}\n\n.table-bar-fill {\n    height: 100%;\n    border-radius: var(--radius-full);\n    transition: width 0.4s ease;\n}\n\n.bg-emerald {\n    background-color: var(--color-emerald);\n}\n\n.bg-amber {\n    background-color: var(--color-amber);\n}\n\n.bg-slate {\n    background-color: #94a3b8;\n}\n\n.table-bar-pct {\n    font-size: 10.5px;\n    font-weight: 700;\n    color: var(--text-heading);\n    width: 26px;\n    text-align: right;\n}\n\n.status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 2px 7px;\n    border-radius: var(--radius-full);\n    font-size: 10.5px;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.status-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n}\n\n.status-pill-completed {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n    border: 1px solid var(--color-emerald-border);\n}\n\n.status-pill-completed .status-dot {\n    background-color: var(--color-emerald);\n}\n\n.status-pill-progress {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n    border: 1px solid var(--color-amber-border);\n}\n\n.status-pill-progress .status-dot {\n    background-color: var(--color-amber);\n}\n\n.status-pill-pending {\n    background: var(--surface-subtle);\n    color: var(--text-muted);\n    border: 1px solid var(--surface-border);\n}\n\n.status-pill-pending .status-dot {\n    background-color: var(--text-light);\n}\n\n.task-action-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    padding: 3px 8px;\n    background: var(--brand-primary-light);\n    border: 1px solid #c7d2fe;\n    color: var(--brand-primary);\n    text-decoration: none;\n    font-size: 10.5px;\n    font-weight: 600;\n    border-radius: var(--radius-sm);\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.task-action-chip:hover {\n    background: var(--brand-primary);\n    color: #ffffff;\n    border-color: var(--brand-primary);\n    transform: translateY(-1px);\n}\n\n.table-empty-state {\n    padding: 24px 14px !important;\n    text-align: center;\n}\n\n.empty-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: var(--text-light);\n}\n\n.empty-icon {\n    font-size: 24px;\n    margin-bottom: 4px;\n}\n\n/* Modern Sleek Scrollbars */\n.table-responsive-wrapper,\n.deliverables-stack-list,\n.activity-timeline-feed {\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e1 transparent;\n}\n\n.table-responsive-wrapper::-webkit-scrollbar,\n.deliverables-stack-list::-webkit-scrollbar,\n.activity-timeline-feed::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n}\n\n.table-responsive-wrapper::-webkit-scrollbar-track,\n.deliverables-stack-list::-webkit-scrollbar-track,\n.activity-timeline-feed::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.table-responsive-wrapper::-webkit-scrollbar-thumb,\n.deliverables-stack-list::-webkit-scrollbar-thumb,\n.activity-timeline-feed::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 4px;\n}\n\n.table-responsive-wrapper::-webkit-scrollbar-thumb:hover,\n.deliverables-stack-list::-webkit-scrollbar-thumb:hover,\n.activity-timeline-feed::-webkit-scrollbar-thumb:hover {\n    background: #94a3b8;\n}\n\n/* Side Widgets Column (Right Column) */\n.side-widgets-column {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    height: 100%;\n    min-height: 0;\n}\n\n/* Deliverables Card */\n.deliverables-card {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 auto;\n    max-height: 220px;\n}\n\n.deliverables-stack-list {\n    padding: 8px 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    max-height: 165px;\n    overflow-y: auto;\n}\n\n.deliverable-item-card {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 8px;\n    background: #fafbfc;\n    border: 1px solid var(--surface-border-subtle);\n    border-radius: var(--radius-sm);\n    transition: all 0.2s ease;\n}\n\n.deliverable-item-card:hover {\n    background: #ffffff;\n    border-color: #cbd5e1;\n    box-shadow: var(--shadow-subtle);\n    transform: translateX(2px);\n}\n\n.date-calendar-box {\n    width: 32px;\n    height: 34px;\n    border-radius: 6px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.box-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n    border: 1px solid var(--color-emerald-border);\n}\n\n.box-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n    border: 1px solid var(--color-amber-border);\n}\n\n.box-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n    border: 1px solid var(--color-purple-border);\n}\n\n.cal-day {\n    font-family: var(--font-heading);\n    font-size: 12.5px;\n    font-weight: 800;\n    line-height: 1;\n}\n\n.cal-month {\n    font-size: 8px;\n    font-weight: 700;\n    letter-spacing: 0.3px;\n    margin-top: 1px;\n}\n\n.deliverable-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.deliverable-name {\n    font-size: 11.5px;\n    font-weight: 700;\n    color: var(--text-heading);\n    margin: 0 0 2px 0;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.deliverable-badges {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.status-micro-pill {\n    font-size: 9px;\n    font-weight: 700;\n    padding: 1px 4px;\n    border-radius: var(--radius-full);\n}\n\n.micro-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n}\n\n.micro-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n}\n\n.micro-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n}\n\n.deliverable-due-text {\n    font-size: 10px;\n    color: var(--text-light);\n}\n\n.empty-deliverables-box,\n.empty-activity-box {\n    padding: 18px;\n    text-align: center;\n    color: var(--text-light);\n    font-size: 11.5px;\n}\n\n.empty-deliverables-box i,\n.empty-activity-box i {\n    font-size: 20px;\n    display: block;\n    margin-bottom: 4px;\n}\n\n/* Activity Feed Card */\n.activity-feed-card {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    min-height: 0;\n}\n\n.activity-timeline-feed {\n    padding: 10px 12px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    gap: 4px;\n}\n\n.activity-timeline-node {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n    flex: 1;\n    min-height: 36px;\n    padding: 2px 0;\n}\n\n.activity-timeline-node:not(:last-child)::after {\n    content: '';\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    height: 100%;\n    width: 2px;\n    background-color: var(--surface-subtle);\n    z-index: 1;\n}\n\n.timeline-indicator-icon {\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    flex-shrink: 0;\n    position: relative;\n    z-index: 2;\n}\n\n.node-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n    border: 1px solid var(--color-emerald-border);\n}\n\n.node-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n    border: 1px solid var(--color-amber-border);\n}\n\n.node-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n    border: 1px solid var(--color-purple-border);\n}\n\n.node-sky {\n    background: var(--color-sky-light);\n    color: var(--color-sky);\n    border: 1px solid var(--color-sky-border);\n}\n\n.timeline-node-body {\n    flex: 1;\n    min-width: 0;\n    padding-top: 1px;\n}\n\n.activity-task-title {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: var(--text-heading);\n    margin-bottom: 2px;\n    line-height: 1.25;\n}\n\n.activity-meta-line {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n    color: var(--text-muted);\n    flex-wrap: wrap;\n}\n\n.activity-status-tag {\n    font-size: 8.5px;\n    font-weight: 700;\n    padding: 1px 4px;\n    border-radius: 3px;\n}\n\n.tag-green {\n    background: var(--color-emerald-light);\n    color: var(--color-emerald);\n}\n\n.tag-amber {\n    background: var(--color-amber-light);\n    color: var(--color-amber);\n}\n\n.tag-purple {\n    background: var(--color-purple-light);\n    color: var(--color-purple);\n}\n\n.tag-sky {\n    background: var(--color-sky-light);\n    color: var(--color-sky);\n}\n\n.activity-assignee strong {\n    color: var(--text-body);\n}\n\n.activity-timestamp {\n    color: var(--text-light);\n}\n\n/* ==========================================================================\n   RESPONSIVE\n   ========================================================================== */\n\n@media (max-width: 1400px) {\n    .stats-kpi-grid {\n        grid-template-columns: repeat(5, 1fr);\n    }\n\n    .bottom-dashboard-grid {\n        grid-template-columns: 1.6fr 1fr 1.1fr;\n    }\n}\n\n@media (max-width: 1200px) {\n    .stats-kpi-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .analytics-spotlight-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .bottom-dashboard-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 992px) {\n    .btn-mobile-sidebar-toggle {\n        display: inline-flex;\n    }\n\n    .btn-sidebar-close-mobile {\n        display: inline-flex;\n    }\n\n    .sidebar-mobile-backdrop {\n        display: block;\n        position: fixed;\n        inset: 0;\n        background: rgba(15, 23, 42, 0.5);\n        backdrop-filter: blur(3px);\n        -webkit-backdrop-filter: blur(3px);\n        z-index: 998;\n        opacity: 0;\n        pointer-events: none;\n        transition: opacity 0.25s ease;\n    }\n\n    body.sidebar-mobile-open .sidebar-mobile-backdrop {\n        opacity: 1;\n        pointer-events: auto;\n    }\n\n    .dash-sidebar {\n        position: fixed;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        width: 270px;\n        max-width: 84vw;\n        z-index: 999;\n        transform: translateX(-100%);\n        transition: transform 0.28s cubic-bezier(0.16, 1, 0.3, 1);\n        box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);\n        background: #ffffff;\n        padding: 16px;\n        overflow-y: auto;\n    }\n\n    body.sidebar-mobile-open .dash-sidebar {\n        transform: translateX(0);\n    }\n\n    .dash-sidebar .sidebar-logo {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 0 14px 0;\n        margin-bottom: 14px;\n        border-bottom: 1px solid var(--surface-border-subtle);\n    }\n\n    .dash-sidebar .sidebar-logo img {\n        display: block !important;\n        height: 28px;\n        max-width: 140px;\n        object-fit: contain;\n    }\n\n    .dash-sidebar .menu-item-link span,\n    .dash-sidebar .sidebar-help-card,\n    .dash-sidebar .sidebar-footer {\n        display: block !important;\n    }\n\n    .dash-sidebar .menu-item-link {\n        justify-content: flex-start !important;\n        padding: 9px 12px !important;\n    }\n\n    .dash-main {\n        margin-left: 0 !important;\n        width: 100% !important;\n        padding: 12px 14px 24px 14px !important;\n    }\n\n    .stats-kpi-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n\n    .support-kpi-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n}\n\n@media (max-width: 768px) {\n    .dashboard-hero-bar {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n        padding: 14px;\n    }\n\n    .hero-welcome-info {\n        width: 100%;\n    }\n\n    .hero-title-row {\n        flex-wrap: wrap;\n        gap: 6px;\n    }\n\n    .hero-controls {\n        width: 100%;\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n\n    .project-dropdown-wrapper {\n        flex: 1;\n        min-width: 140px;\n    }\n\n    .btn-create-ticket-primary {\n        flex: 1;\n        min-width: 140px;\n        justify-content: center;\n    }\n\n    .projects-main-card {\n        height: auto;\n        min-height: calc(100vh - 120px);\n    }\n}\n\n@media (max-width: 576px) {\n    .dash-header {\n        margin-bottom: 10px;\n        padding-bottom: 8px;\n    }\n\n    .header-page-title h3 {\n        font-size: 15px;\n    }\n\n    .user-profile-details {\n        display: none;\n    }\n\n    .user-profile-card {\n        padding: 0;\n        background: transparent;\n        border: none;\n        box-shadow: none;\n    }\n\n    .logout-btn-styled span {\n        display: none;\n    }\n\n    .logout-btn-styled {\n        padding: 6px 8px;\n        border-radius: 6px;\n    }\n\n    .stats-kpi-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .support-kpi-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .support-kpi-card {\n        padding: 12px;\n    }\n\n    .support-kpi-val {\n        font-size: 18px;\n    }\n\n    .project-select-container {\n        width: 100%;\n    }\n\n    .project-meta-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .card-header-actions {\n        width: 100%;\n        gap: 6px;\n    }\n\n    .support-search-wrap {\n        width: 100% !important;\n    }\n\n    .custom-popover-dropdown {\n        flex: 1;\n        min-width: 110px;\n    }\n\n    .custom-dropdown-btn {\n        width: 100%;\n    }\n\n    .modal-dialog {\n        margin: 8px;\n    }\n}\n\n/* ==========================================================================\n   RIGHT-TO-LEFT NOTIFICATION DRAWER / SLIDE-OVER MODAL\n   ========================================================================== */\n\n.notif-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(15, 23, 42, 0.45);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    z-index: 1040;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.25s ease, visibility 0.25s ease;\n}\n\n.notif-backdrop.open {\n    opacity: 1;\n    visibility: visible;\n}\n\n.notif-drawer-modal {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 490px;\n    max-width: 92vw;\n    height: 100vh;\n    background: #ffffff;\n    box-shadow: -8px 0 40px -2px rgba(15, 23, 42, 0.2);\n    z-index: 1050;\n    display: flex;\n    flex-direction: column;\n    transform: translateX(100%);\n    transition: transform 0.32s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.notif-drawer-modal.open {\n    transform: translateX(0);\n}\n\n.notif-drawer-header {\n    padding: 20px 22px;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #ffffff;\n}\n\n.notif-header-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.notif-header-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.notif-header-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 17px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0;\n    letter-spacing: -0.3px;\n}\n\n.notif-unread-count {\n    font-size: 11px;\n    font-weight: 700;\n    background: #ecfdf5;\n    color: #065f46;\n    border: 1px solid #a7f3d0;\n    padding: 2px 8px;\n    border-radius: 9999px;\n}\n\n.notif-close-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.notif-close-btn:hover {\n    background: #eef2ff;\n    color: #4f46e5;\n    border-color: #c7d2fe;\n}\n\n.notif-drawer-tabs {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 20px;\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.notif-tab-pills {\n    display: flex;\n    background: #e2e8f0;\n    padding: 3px;\n    border-radius: 8px;\n    gap: 2px;\n}\n\n.notif-tab-btn {\n    border: none;\n    background: transparent;\n    padding: 4px 10px;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.notif-tab-btn.active {\n    background: #ffffff;\n    color: #4f46e5;\n    font-weight: 700;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);\n}\n\n.notif-mark-read-btn {\n    border: none;\n    background: transparent;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #4f46e5;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    transition: color 0.15s ease;\n}\n\n.notif-mark-read-btn:hover {\n    color: #3730a3;\n    text-decoration: underline;\n}\n\n.notif-drawer-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 12px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.notif-item-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 14px;\n    display: flex;\n    gap: 12px;\n    align-items: flex-start;\n    position: relative;\n    transition: all 0.2s ease;\n    cursor: pointer;\n}\n\n.notif-item-card:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);\n}\n\n.notif-item-card.unread {\n    background: #faf5ff;\n    border-color: #e9d5ff;\n}\n\n.notif-item-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    flex-shrink: 0;\n}\n\n.notif-icon-milestone { background: #ecfdf5; color: #10b981; }\n.notif-icon-task      { background: #eef2ff; color: #4f46e5; }\n.notif-icon-doc       { background: #fff1f2; color: #e11d48; }\n.notif-icon-system    { background: #f5f3ff; color: #7c3aed; }\n.notif-icon-support   { background: #fffbeb; color: #d97706; }\n\n.notif-item-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.notif-item-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 3px;\n}\n\n.notif-item-title {\n    font-size: 13px;\n    font-weight: 700;\n    color: #0f172a;\n    line-height: 1.3;\n}\n\n.notif-dot-unread {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #8b5cf6;\n    flex-shrink: 0;\n}\n\n.notif-item-desc {\n    font-size: 12px;\n    color: #64748b;\n    margin: 0 0 6px 0;\n    line-height: 1.4;\n}\n\n.notif-item-time {\n    font-size: 11px;\n    color: #94a3b8;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.notif-dismiss-btn {\n    border: none;\n    background: transparent;\n    color: #94a3b8;\n    font-size: 12px;\n    cursor: pointer;\n    padding: 2px 4px;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n}\n\n.notif-dismiss-btn:hover {\n    color: #e11d48;\n    background: #fff1f2;\n}\n\n.notif-drawer-footer {\n    padding: 14px 20px;\n    border-top: 1px solid #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #ffffff;\n}\n\n.notif-footer-action {\n    font-size: 12px;\n    font-weight: 600;\n    color: #64748b;\n    text-decoration: none;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    transition: color 0.15s ease;\n}\n\n.notif-footer-action:hover {\n    color: #0f172a;\n}\n\n.notif-footer-action.danger:hover {\n    color: #e11d48;\n}\n\n/* Empty notifications */\n.notif-empty-state {\n    padding: 60px 20px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.notif-empty-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    background: #f1f5f9;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 26px;\n    margin-bottom: 14px;\n}\n\n.notif-empty-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 4px;\n}\n\n.notif-empty-desc {\n    font-size: 12.5px;\n    color: #94a3b8;\n    max-width: 260px;\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
